module.exports = __webpack_public_path__ + "static/media/Back.fff9dc9c.svg";